// extracted by mini-css-extract-plugin
export default {"name":"EZhTe","period":"AWEvS","clarification":"bgiqU","tabs":"YTiQM"};